var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeChat)?_c('Conversation'):_c('ContactList',{staticClass:"scrollable__y h-screen w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }